import { motion } from "framer-motion";

const Invite = () => {
    return (
        <section className="flex w-full min-h-full flex-col justify-center gap-12 px-4">
            <motion.div
                className="flex justify-center gap-4 max-w-full w-80 mx-auto text-3xl"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.5 }}
            >
                <div className="whitespace-nowrap flex flex-col justify-center flex-auto">
                    <p className="text-center border-y-2">MAR</p>
                </div>
                <div className="whitespace-nowrap text-2xl flex flex-col gap-2">
                    <p className="text-center">Saturday</p>
                    <p className="text-center text-5xl font-bold">21</p>
                    <p className="text-center">4.00 pm</p>
                </div>
                <div className="whitespace-nowrap flex-col flex justify-center flex-auto">
                    <p className="text-center border-y-2">2026</p>
                </div>
            </motion.div>
            <motion.div
                className="flex justify-center flex-col gap-2 w-full text-center text-xl"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.3 }}
            >
                <p>6 Cintra Way, Landsdale WA 6065</p>
                <p><span className="font-bold">Dress Code:</span> Garden Party Cocktail</p>
            </motion.div>
        </section>
    )
}

export default Invite;